module.exports = __webpack_public_path__ + "media/images/icon-member-care-223c9449c39f947245c3149f86e7417c.png";